import { call, put, takeLatest } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';

const endpoint = `${config.credentials.url}/age-group`;

function* getAgeGroup(actions) {
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
    };

    const requestOptions = {
      headers,
    };

    const query = actions.query ? `?${new URLSearchParams(actions.query).toString()}` : "";
    const url = config.credentials.url + "/age-group/" + query;

    const response = yield call(
      apiCall,
      "get",
      url,
      requestOptions
    );

    yield put({
      type: "AGE_GROUP_RESPONSE",
      value: response,
    });

  } catch (error) {
    yield put({
      type: "AGE_GROUP_ERROR",
      error,
    });
  }
}



// DETALLE
function* getAgeGroupDetail(actions) {
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
    };

    const requestOptions = {
      headers,
    };

    const url =
      config.credentials.url + "/age-group/" + actions.id + "/";

    const response = yield call(
      apiCall,
      "get",
      url,
      requestOptions
    );

    yield put({
      type: "AGE_GROUP_DETAIL_RESPONSE",
      value: response,
    });

  } catch (error) {
    yield put({
      type: "AGE_GROUP_DETAIL_ERROR",
      error,
    });
  }
}


// CREATE
function* createAgeGroup({ access, payload }) {
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    };

    const requestOptions = {
      headers,
      body: JSON.stringify(payload),
    };

    const response = yield call(
      apiCall,
      "POST",
      `${endpoint}/`,
      requestOptions
    );

    yield put({
      type: 'AGE_GROUP_CREATE_RESPONSE',
      value: response,
    });
  } catch (error) {
    yield put({
      type: 'AGE_GROUP_CREATE_ERROR',
      error,
    });
  }
}

// UPDATE
function* updateAgeGroup({ access, id, payload }) {
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    };

    const requestOptions = {
      headers,
      body: JSON.stringify(payload),
    };

    const response = yield call(
      apiCall,
      "PATCH",
      `${endpoint}/${id}/`,
      requestOptions
    );

    yield put({
      type: 'AGE_GROUP_UPDATE_RESPONSE',
      value: response,
    });
  } catch (error) {
    yield put({
      type: 'AGE_GROUP_UPDATE_ERROR',
      error,
    });
  }
}

export default function* sagaAgeGroup() {
  yield takeLatest('AGE_GROUP_REQUEST', getAgeGroup);
  yield takeLatest('AGE_GROUP_DETAIL_REQUEST', getAgeGroupDetail);
  yield takeLatest('AGE_GROUP_CREATE_REQUEST', createAgeGroup);
  yield takeLatest('AGE_GROUP_UPDATE_REQUEST', updateAgeGroup);
}